export const channelNames = {
    INBOX_MESSAGES: 'inbox_message_realtime_notification',
    PINNED_FLASHES: 'pinned_flash_realtime_notification',
};
